import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
      <div className="relative">
        <img 
          src="/logo-full.png" 
          alt="Tilted" 
          className="w-[300px] max-w-full animate-pulse"
        />
      </div>
      <p className="text-gray-400 font-body text-sm animate-pulse">
        Pouring your data...
      </p>
    </div>
  );
}

export default LoadingSpinner;


